var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8293 0.493652H9.27048C4.42952 0.493652 0.505493 4.4177 0.505493 9.25867V19.1579C0.505493 23.9988 4.42952 27.9229 9.27048 27.9229H31.8293C36.6703 27.9229 40.5943 23.9988 40.5943 19.1579V9.25867C40.5943 4.4177 36.6703 0.493652 31.8293 0.493652ZM28.1894 14.4689L18.1008 19.4412C17.7068 19.6546 16.3298 19.3688 16.3298 18.9207V8.71344C16.3298 8.25975 17.7179 7.97478 18.1119 8.19924L27.7517 13.4334C28.1552 13.6642 28.5977 14.2477 28.1894 14.4689Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4bf5db20ba1887cb64b481524f0d3e98.svg";
export { ForwardRef as ReactComponent };